import { AppTransitionsOptions } from '../IMaterial';

export const initializeTransitions = (config?: AppTransitionsOptions): AppTransitionsOptions => {
  return {
    ...config,
  };
};
